export default __webpack_public_path__ + "static/media/cp_geo_zm.2d02ca9d.svg";